export default __webpack_public_path__ + "static/media/mountain-1.f076c2db.png";